module.exports = __webpack_public_path__ + "img/support_moni_mb_2.6a4dfb23.jpg";